export const templateVariables = {
  FIRSTNAME: 'First Name',
  FULLNAME: 'Full Name',
  BRANDNAME: 'Brand Name'
};

export const templateVariableOptions = Object.entries(templateVariables).map(([key, value]) => ({ value: `{{${key}}}`, label: value }));

export const variableAliases = {
  FIRSTNAME: ['firstname', 'first_name', 'first name', 'fname', 'first', 'fristname', 'fisrname', 'fistname', 'firstnme', 'fisrtname', 'name.first'],
  FULLNAME: ['fullname', 'full_name', 'full name', 'name.full'],
  BRANDNAME: ['brandname', 'brand_name', 'brand name', 'brand']
};

// Template alias patterns
export const templatePatterns = [
  { pattern: /\{\{\{\s*([^}]+?)\s*\}\}\}/gi, type: 'triple' },
  { pattern: /\{\{\s*([^}]+?)\s*\}\}/gi, type: 'double' },
  { pattern: /\[\[\s*([^[\]]+?)\s*\]\]/gi, type: 'square' },
  { pattern: /<<\s*([^<>]+?)\s*>>/gi, type: 'angle' },
  { pattern: /%([A-Za-z_][A-Za-z0-9_\s]*?)%/gi, type: 'percent' },
  { pattern: /\$([A-Za-z_][A-Za-z0-9_]*?)(?=\s|$|[^A-Za-z0-9_])/gi, type: 'dollar' }
];

export const bracketedPattern = /\{\s*([A-Za-z_][A-Za-z0-9_\s]*?)\s*\}/gi;

export const standaloneConfigForGreetings = [
  { pattern: /\b(firstname|first[_\s]?name|fname|first)\b/gi, replacement: '{{FIRSTNAME}}' },
  { pattern: /\b(fullname|full[_\s]?name)\b/gi, replacement: '{{FULLNAME}}' },
  { pattern: /\b(brand|brandname|brand[_\s]?name)\b/gi, replacement: '{{BRANDNAME}}' }
];

export const exactMatchDistanceThreshold = 1;

export const fuzzyMatchDistanceThreshold = 2;
